import React, { useMemo } from 'react';
import { ISlimApp } from '@biolibtech/biolib-js';
import ResourceListItem from './ResourceListItem';
import SearchModalComboboxOption from './SearchModalComboboxOption';

interface IProps {
    resources: ISlimApp[];
    isLoading: boolean;
    prefetchedMatches: ISlimApp[];
}

export default function SearchModalResourceList(props: IProps) {
    const { resources, isLoading, prefetchedMatches } = props;

    const displayedResources = useMemo(() => {
        const prefetchedSlice = prefetchedMatches.slice(0, 5);
        if (isLoading) {
            return prefetchedSlice;
        }
        const prefetchedIds = new Set(prefetchedSlice.map((app) => app.uuid));
        const remainingSlots = Math.max(0, 5 - prefetchedSlice.length);
        const additionalResults = resources.filter((r) => !prefetchedIds.has(r.uuid)).slice(0, remainingSlots);
        return [...prefetchedSlice, ...additionalResults];
    }, [prefetchedMatches, resources, isLoading]);

    const skeletonCount = isLoading ? Math.max(0, 5 - displayedResources.length) : 0;

    return (
        <>
            {displayedResources.map((resource) => (
                <SearchModalComboboxOption path={`/${resource.resource_uri}/`} key={resource.uuid}>
                    <ResourceListItem
                        item={resource}
                        contextData={{ isAccountHandleShown: true, showProfilePicture: true }}
                        asLink={false}
                        className='px-3 select-none'
                    />
                </SearchModalComboboxOption>
            ))}
            {Array.from({ length: skeletonCount }).map((_, index) => (
                <ResourceListItem
                    key={`skeleton-${index}`}
                    item={null}
                    asLink={false}
                    contextData={{ isAccountHandleShown: true, showProfilePicture: true }}
                    className='px-3 select-none'
                />
            ))}
        </>
    );
}
